import qs from 'qs'
import { CtServiceDeps, CtAccessTokenInterface } from '../../types'
import { HttpClientRequired } from '../../utils/HttpClientRequired'

export const accessTokenAnonymousFetchService = async ({
  httpClient,
  params,
}: Omit<
  CtServiceDeps<{
    projectKey: string
    clientId: string
    clientSecret: string
    host: string
  }>,
  'token'
>) => {
  if (!httpClient) {
    throw new HttpClientRequired()
  }

  const res = await httpClient.post<CtAccessTokenInterface>(
    `https://auth.${params?.host}/oauth/${params?.projectKey}/anonymous/token`,
    qs.stringify({
      grant_type: 'client_credentials',
    }),
    {
      auth: {
        username: params?.clientId ?? '',
        password: params?.clientSecret ?? '',
      },
      headers: {
        'content-type': 'application/x-www-form-urlencoded',
      },
      baseURL: undefined,
    }
  )

  return res.data
}

export const accessTokenRefreshService = async ({
  httpClient,
  params,
}: Omit<
  CtServiceDeps<{
    token: string
    projectKey: string
    clientId: string
    clientSecret: string
    host: string
  }>,
  'token'
>) => {
  if (!httpClient) {
    throw new HttpClientRequired()
  }

  const res = await httpClient.post<CtAccessTokenInterface>(
    `https://auth.${params?.host}/oauth/token`,
    qs.stringify({
      grant_type: 'refresh_token',
      refresh_token: params?.token,
    }),
    {
      auth: {
        username: params?.clientId ?? '',
        password: params?.clientSecret ?? '',
      },
      headers: {
        'content-type': 'application/x-www-form-urlencoded',
      },
      baseURL: undefined,
    }
  )

  return res.data
}

export const accessTokenCustomerFetchService = async ({
  httpClient,
  params,
}: Omit<
  CtServiceDeps<{
    username: string
    password: string
    projectKey: string
    clientId: string
    clientSecret: string
    host: string
  }>,
  'token'
>) => {
  if (!httpClient) {
    throw new HttpClientRequired()
  }

  const res = await httpClient.post<CtAccessTokenInterface>(
    `https://auth.${params?.host}/oauth/${params?.projectKey}/customers/token`,
    qs.stringify({
      grant_type: 'password',
      username: params?.username,
      password: params?.password,
    }),
    {
      auth: {
        username: params?.clientId ?? '',
        password: params?.clientSecret ?? '',
      },
      headers: {
        'content-type': 'application/x-www-form-urlencoded',
      },
      baseURL: undefined,
    }
  )

  return res.data
}
